module.exports = __webpack_public_path__ + "static/media/img-perfil.296257e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Application/scenes/Site/Body/scenes/Portfolio/About/AboutHeader/img/img-perfil.jpg
// module id = 479
// module chunks = 0